import {FormFieldWidget, http, ModelFieldType, SPI, ViewType, Widget, WidgetSubjection} from '@kunlun/dependencies';
import {OioNotification} from '@kunlun/vue-ui-antd';
import {notification} from 'ant-design-vue';
import ScanPrint from './ScanPrint.vue';
import {initLodop, lodopHtmlBarCode, lodopPDFBarCode} from './util/lodopFdfBase64';

interface IdataType {
    id: string;
    exhibitionId: string;
    exhibitionCode: string;
    exhibitionName: string;
    brandName: string;
    itemName: string;
    itemCode: string;
    barCode: string;
    itemNumber: string;
    itemSalesUnitPrice: string;
    displayArea?: string;
    remark?: string;
    priceType: string;
}

interface Isearch {
    barCode: string;
    itemNumber: string;
    area: string;
    printerValue: string;
    printerTemp: string;
}

@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: ViewType.Detail,
        ttype: ModelFieldType.String,
        widget: 'ScanPrint',
        multi: false
    })
)
export class DetailStringScanPrintFieldWidget extends FormFieldWidget {
    lodop: any;

    @Widget.Reactive()
    printerOptions: any[] = [];

    @Widget.Reactive()
    dataSourceList: IdataType[] = [];

    @Widget.Reactive()
    isShowPrintBtn = false;

    @Widget.Reactive()
    selectedRowKeys: Array<string> = [];

    @Widget.Reactive()
    dataSourceWait: IdataType[] = [];

    @Widget.Reactive()
    selectedRows;

    @Widget.Reactive()
    searchParams: Isearch = {barCode: '', itemNumber: '', area: '', printerValue: 'ITEM', printerTemp: 'NEW_HTML'};

    private reload$!: WidgetSubjection<boolean | string>;

    private exhibitionCode = '';

    private canPrintNext = true;

    private canBatchPrintNext = true;

    private printParamsArr: any[] = [];

    private printInterval: any = null;

    private prevBarCode = '';

    @Widget.Reactive()
    private viewName: string = '';

    public initialize(props) {
        super.initialize(props);
        this.setComponent(ScanPrint);
        this.viewName = this.view!.name!;
        return this;
    }

    protected mounted(): void {
        if (this.field.model === 'deli.merchant.DeliAriesMerchantExhibitItemScan') {
            const css = document.querySelector('.ant-form-item-label') as HTMLElement;
            css.style.display = 'none';
        }

        const lodop = initLodop();
        this.lodop = lodop;
        const printerNum = lodop?.GET_PRINTER_COUNT();
        const printers: any[] = [];

        for (let i = 0; i < printerNum; i++) {
            printers.push({value: lodop.GET_PRINTER_NAME(i)});
        }
        this.printerOptions = printers;

        // this.printerOptions = this.printerOptions.concat([
        //   {
        //     value: '默认打印机'
        //   },
        //   {
        //     value: '超级打印机'
        //   }
        // ]);

        this.startPrintInterval();
    }

    protected beforeUnmount(): void {
        super.beforeUnmount();
        clearInterval(this.printInterval);
    }

    @Widget.Method()
    onSelectChange(selectedRowKeys: Array<string>, selectedRows: IdataType) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
    }

    @Widget.Method()
    async backAndSaveIds() {
        history.back();
        this.reload$.subject.next(true);
    }

    async savePrint(id) {
        const modelMap = {
            deliAriesCoreMerchant: 'deliAriesMerchantExhibitItemMutation',
            deliAriesCoreSeller: 'deliAriesSellerExhibitItemMutation',
            deliAriesCorePlatform: 'deliAriesPlatformExhibitItemMutation'
        };
        try {
            const query = `
        mutation {
          ${modelMap[this.model.moduleName]} {
            isPrint(
              exhibitItemIds: ${id}
              exhibitCode: "${this.exhibitionCode}"
            )
          }
        }
      `;
            await http.query(this.model.moduleName, query);
        } catch (error) {
            console.error(error);
            OioNotification.error('错误', error as string);
        }
    }

    @Widget.Method()
    async onPrintf() {
        let interval: any = null;
        this.canPrintNext = false;

        interval = setInterval(async () => {
            if (!this.canBatchPrintNext) {
                return;
            }
            const id = this.selectedRowKeys.shift();
            if (!id) {
                this.canPrintNext = true;
                clearInterval(interval);
                return;
            }

            this.canBatchPrintNext = false;

            try {
                const curRow = this.selectedRows.shift();

                const html = await this.getPrintHtml(id);

                lodopPDFBarCode(html, 'print', this.lodop);
                this.dataSourceWait.push(curRow);

                const index = this.dataSourceList.findIndex((v) => v.id === id);
                this.dataSourceList.splice(index, 1);

                await this.savePrint(id);
            } catch (error) {
                console.error(error);
            } finally {
                this.canBatchPrintNext = true;
            }
        }, 300);
    }

    async getPrintHtml(id) {
        const modelMap = {
            deliAriesCoreMerchant: 'deliAriesMerchantExhibitItemQrCodePrintHtmlQuery',
            deliAriesCoreSeller: 'deliAriesSellerExhibitItemQrCodePrintHtmlQuery',
            deliAriesCorePlatform: 'deliAriesPlatformExhibitItemQrCodePrintHtmlQuery'
        };
        const query = `
      query {
        ${modelMap[this.model.moduleName]} {
          construct(
            data: {},
            exhibitItem: {
              id: "${id}"
              printerValue: ${this.searchParams.printerValue}
              printerTemp: ${this.searchParams.printerTemp}
            }
          )
          {
            isSingleQrCode
            html
          }
        }
      }`;
        console.log(query);
        try {
            const result = await http.query(this.model.moduleName, query);
            const html = result.data[modelMap[this.model.moduleName]].construct;
            // this.resetParams();

            return html.html;
        } catch (error) {
            console.error(error);
        }
    }

    @Widget.Watch('selectedRowKeys', {deep: true})
    watchValue(selectedRowKeys) {
        if (selectedRowKeys.length > 0) {
            this.isShowPrintBtn = true;
        } else {
            this.isShowPrintBtn = false;
        }
    }

    @Widget.Method()
    resetParams() {
        this.searchParams.barCode = '';
        this.searchParams.itemNumber = '';
        this.searchParams.area = '';
        this.searchParams.printerValue = 'ITEM';
        this.searchParams.printerTemp = 'NEW_HTML';
    }

    @Widget.Method()
    async onEnterSearch() {
        if (this.searchParams.barCode.trim() === '' && this.searchParams.itemNumber.trim() === '' && this.searchParams.area.trim() === '') {
            notification.error({
                message: '提示',
                description: '搜索项为空，请输入至少一个搜索项'
            });
            return;
        }

        this.searchParams.barCode = this.searchParams.barCode.replace(this.prevBarCode, '');
        this.printParamsArr.push({...this.searchParams});
        this.prevBarCode = this.searchParams.barCode;
    }

    async startPrintInterval() {
        this.printInterval = setInterval(async () => {
            const params: Isearch = this.printParamsArr.pop();
            if (!this.canPrintNext || !params) {
                return;
            }

            this.canPrintNext = false;

            let rsql = '';
            if (this.searchParams.area) {
                rsql = `rsql:"(1==1) and (((((1==1) and (exhibitionId=like='%${this.formData.id}%')) and (itemNumber=like='%${params.itemNumber}%')) and (barCode=like='%${params.barCode}%')) and (displayArea=like='%${params.area}%'))"`;
            } else {
                rsql = `rsql:"(1==1) and ((((1==1) and (exhibitionId=like='%${this.formData.id}%')) and (itemNumber=like='%${params.itemNumber}%')) and (barCode=like='%${params.barCode}%'))"`;
            }

            const modelMap = {
                deliAriesCoreMerchant: 'deliAriesMerchantExhibitItemScanQuery',
                deliAriesCoreSeller: 'deliAriesSellerExhibitItemScanQuery',
                deliAriesCorePlatform: 'deliAriesPlatformExhibitItemScanQuery'
            };

            let query = `
        query{
          ${modelMap[this.model.moduleName]} {
            queryPage(
              page: { currentPage: 1, size: 100 }
              queryWrapper: {
                ${rsql}
              }
            ) {
              content {
                id
                exhibitionId
                exhibitionCode
                exhibitionName
                brandName
                itemName
                itemCode
                itemNumber
                barCode
                priceType
                itemSalesUnitPrice
                displayArea
                remark
              }
            }
          }
        }      
      `;

            try {
                query = query.replace(/[\r\n\t]/gm, ' ').replace(/\s+/gm, ' ');

                const result = await http.query(this.model.moduleName, query);
                const content = result.data[modelMap[this.model.moduleName]].queryPage as { content: IdataType[] };
                this.exhibitionCode = content.content[0].exhibitionCode;

                if (content.content.length > 0) {
                    content.content.forEach((item: IdataType) => {
                        item.itemSalesUnitPrice = (Math.round(Number(item.itemSalesUnitPrice) * 100) / 100).toString();
                    });
                }

                if (content.content.length === 1) {
                    const html = await this.getPrintHtml(content.content[0].id);
                    this.dataSourceWait.push(content.content[0]);

                    lodopPDFBarCode(html, 'print', this.lodop);
                    await this.savePrint(content.content[0].id);
                } else {
                    this.dataSourceList = content.content;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.canPrintNext = true;
            }
        }, 300);
    }

    @Widget.Method()
    printerChange(value) {
        if (value) {
            sessionStorage.setItem('printName', value.value);
        }
    }
}
